import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { h as hasSlot } from './slot.js';

const cardCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{--border-color:var(--sl-color-gray-200);--border-radius:var(--sl-border-radius-medium);--border-width:1px;--padding:var(--sl-spacing-large);display:inline-block}.card{display:flex;flex-direction:column;background-color:var(--sl-color-white);box-shadow:var(--sl-shadow-x-small);border:solid var(--border-width) var(--border-color);border-radius:var(--border-radius)}.card__image{border-top-left-radius:var(--border-radius);border-top-right-radius:var(--border-radius);margin:calc(-1 * var(--border-width));overflow:hidden}.card__image ::slotted(img){display:block;width:100%}.card:not(.card--has-image) .card__image{display:none}.card__header{border-bottom:solid var(--border-width) var(--border-color);padding:calc(var(--padding) / 2) var(--padding)}.card:not(.card--has-header) .card__header{display:none}.card__body{padding:var(--padding)}.card--has-footer .card__footer{border-top:solid var(--border-width) var(--border-color);padding:var(--padding)}.card:not(.card--has-footer) .card__footer{display:none}";

const Card = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.hasFooter = false;
    this.hasImage = false;
    this.hasHeader = false;
  }
  connectedCallback() {
    this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  componentWillLoad() {
    this.handleSlotChange();
  }
  handleSlotChange() {
    this.hasFooter = hasSlot(this.element, 'footer');
    this.hasImage = hasSlot(this.element, 'image');
    this.hasHeader = hasSlot(this.element, 'header');
  }
  render() {
    return (h("div", { part: "base", class: {
        'card': true,
        'card--has-footer': this.hasFooter,
        'card--has-image': this.hasImage,
        'card--has-header': this.hasHeader,
      } }, h("div", { part: "image", class: "card__image" }, h("slot", { name: "image", onSlotchange: this.handleSlotChange })), h("div", { part: "header", class: "card__header" }, h("slot", { name: "header", onSlotchange: this.handleSlotChange })), h("div", { part: "body", class: "card__body" }, h("slot", null)), h("div", { part: "footer", class: "card__footer" }, h("slot", { name: "footer", onSlotchange: this.handleSlotChange }))));
  }
  get element() { return this; }
  static get style() { return cardCss; }
}, [1, "sl-card", {
    "hasFooter": [32],
    "hasImage": [32],
    "hasHeader": [32]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["sl-card"];
  components.forEach(tagName => { switch (tagName) {
    case "sl-card":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Card);
      }
      break;
  } });
}

const SlCard = Card;
const defineCustomElement = defineCustomElement$1;

export { SlCard, defineCustomElement };
